<template>
  <div class="w-100 h-100 m-0 position-relative d-flex flex-column align-items-center" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">初回無料お試しサービス</div>
    <div class="mb-0 text-start" style="margin-top:63px; font-size: 16px; width:552px;">
      <p class="m-0">アンケートに答えて初回無料でアクリルアイテムを作成することができます</p>
      <p class="m-0">これを機にアクリルアイテムを無料で作成してみましょう！</p>
    </div>

    <div class="mb-0" style="margin-top:63px; width:868px; border-bottom: solid 1px #D1D5DB;">
      <p class="text-start">● 通常注文で初回無料お試しサービスを使う</p>
      <div class="cell d-flex">
        <div class="acrypro-text-main-bold d-flex justify-content-between" style="width:180px;">
          <div>ご注文サイズ</div>
        </div>
        <div class="d-flex flex-grow-1" style="gap: 80px;">
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option1" value="S" v-model="selectSize" />
            <div>S</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option2" value="M" v-model="selectSize" />
            <div>M</div>
          </div>
          <div class="d-flex" style="gap: 16px;">
            <input class="input-radio" type="radio" id="option3" value="L" v-model="selectSize" />
            <div>L</div>
          </div>
        </div>
      </div>

      <button class="mx-0 acry-btn fw-bold" style="display:block; width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:48px; margin-bottom:40px;" @click="clickCreateBtn">
        作成する
      </button>
    </div>

    <!-- シェアコード入稿 -->
    <div class="mb-0" style="margin-top:63px; width:868px; border-bottom: solid 1px #D1D5DB;">
      <p class="text-start">● ACRY PROコードで初回無料お試しサービスを使う</p>

      <div class="d-flex" style="gap:64px;">
        <div class="fw-bold" style="font-size: 16px;">
          ACRY PRO用コード
        </div>
        <div class="d-flex flex-column" style="gap:8px;">
          <div>
            ※「ACRY PRO用コード」をお持ちの方は入力してください。
          </div>
          <input type="text" v-model="shareCode" class="forminput acry-text-main" placeholder="半角英数字6文字以上" @keydown.enter="clickShareCode" style="height: 40px;" />
        </div>
      </div>

      <button class="mx-0 acry-btn fw-bold" style="display:block; width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:48px; margin-bottom:40px;" @click="clickShareCode">
        作成する
      </button>
    </div>

    <div class="mb-0 d-flex flex-column align-items-center" style="margin-top:63px; width:868px; background:#F8F8F8; padding:24px 16px;">
      <p class="fw-bold" style="margin-bottom:16px; ">注意事項</p>
      <div class="m-auto d-flex flex-column text-start">
        <p class="m-0" style="font-size: 13px;">・ご利用には契約書へのご署名が必要です。</p>
        <p class="m-0" style="font-size: 13px;">・すでにご契約済みの方もご利用いただけます。</p>
        <p class="m-0" style="font-size: 13px;">・一部機能に制限がございます。</p>
      </div>
    </div>

  </div>
</template>

<script>
import { CenterViewState, RightViewState, ProductId, GetCanvasSize } from "@/js/Const.js";
import { ResizeImageBlob } from "@/js/CommonFunc.js";
import config from "config";
import JSZip from "jszip";
import firebase from "firebase/app";
import axios from "axios";

export default {
  name: "CenterViewFirstTimeFreeTop_Ap",
  props: {},
  data: function () {
    return {
      shareCode:"",
      selectSize:"S",
    };
  },
  computed: {},
  created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("resetFirstTimeFreeData");
    // 次のプレビュー画面のデータを先に初期化しておく
    this.$store.commit("resetCommonPreviewData");
  },
  components: {},
  methods: {
    clickCreateBtn(){
      switch(this.selectSize){
        case "S":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.S_SVG);
          break;
        case "M":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.M_SVG);
          break;
        case "L":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.L_SVG);
          break;
      }

      // プレビュー用のデータを設定
      this.$store.commit("setCommonPreviewSelectProductId", this.$store.state.firstTimeFreeData.selectProductId);

      this.$store.commit("setCenterViewState", CenterViewState.CommonPreview);
      this.$store.commit('setRightViewState', RightViewState.FirstTimeFreeUpload);
    },

    async clickShareCode() {
      if (!this.shareCode) {
        return;
      }

      // シェアコードの小文字を大文字にする
      this.$store.commit("showLoading")
      const designData = await this.getDesignData(this.shareCode);

      if (designData == null || designData.length == 0) {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "存在しないコードです");
        return;
      }

      // プロダクトIDをチェック
      if (
        !["FreeAcrylic1", "FreeAcrylic2", "FreeAcrylic3"].includes(designData.productId)
      ) {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "対象外の商品種別");
        return;
      }

      // 有効期限チェック
      var expireDate = new Date(designData.expireDate.iso);
      var nowDate = new Date();
      if( nowDate > expireDate ){
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "有効期限を過ぎています");
        return;
      }

      // デザインデータのダウンロード
      const url = config.s3DesignFilePath + designData.file;
      const zipData = await this.downloadZipFile(url);
      const blob = new Blob([zipData], { type: "application/zip" });
      const file = new File([blob], "", {});

      const zipdata = await new Promise((resolve) => {
        JSZip.loadAsync(file).then((res) => {
          resolve(res);
        });
      });

      switch (designData.productId) {
        case "FreeAcrylic1":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.L_SHARE);
          break;
        case "FreeAcrylic2":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.M_SHARE);
          break;
        case "FreeAcrylic3":
          this.$store.commit("setFirstTimeFreeSelectProductId", ProductId.S_SHARE);
          break;
      }

      const designBlob = await zipdata.file("forcartimage2.png").async("blob");
      const cutlineBlob = await zipdata.file("forcartimage3.png").async("blob");

      let design = new File([designBlob], "design.png", { type: "image/png" });
      let cutline = new File([cutlineBlob], "cutine.png", { type: "image/png" });

      // アクリルに合わせるためにリサイズを行う
      let canvasSize = GetCanvasSize(this.$store.state.firstTimeFreeData.selectProductId);
      design = await ResizeImageBlob(design, canvasSize.width, canvasSize.height);
      cutline = await ResizeImageBlob(cutline, canvasSize.width, canvasSize.height);

      // プレビュー用のデータを設定
      this.$store.commit("setCommonPreviewSelectProductId", this.$store.state.firstTimeFreeData.selectProductId);
      this.$store.commit("setCommonDesignImageURL", URL.createObjectURL(design));

      // データを保存
      this.$store.commit("setFirstTimeFreeDesignImageFile", design);
      this.$store.commit("setFirstTimeFreeDesignImageURL", URL.createObjectURL(design));
      this.$store.commit("setFirstTimeFreeScCutlineImageFile", cutline);
      this.$store.commit("setFirstTimeFreeScCutlineImageURL", URL.createObjectURL(cutline));

      //this.$store.commit("setIsShareCodeDraft", true);

      this.$store.commit("setCenterViewState", CenterViewState.CommonPreview);
      this.$store.commit('setRightViewState', RightViewState.FirstTimeFreeUpload);
    },
    getDesignData() {
      return new Promise((resolve) => {
        const ref = firebase.firestore().collection("ShareInfo");
        ref.where("key", "==", this.shareCode).get().then((snapshot)=>
        {
          console.log(snapshot.docs);
          const data = snapshot.docs[0].data();
          resolve(data)
        }).catch(()=>
        {
          console.log("error");
          resolve([]);
        });
      });
    },
    async downloadZipFile(url) {
      console.log("download zip :" + url);
      return new Promise((resolve) => {
        axios
          .get(url, {
            responseType: "arraybuffer",
            headers: { Accept: "application/zip" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            resolve();
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.input-radio{
  width: 24px;
  height: 24px;
  accent-color: #8593bc;
}

.forminput {
  width: 100%;
  border: 1px solid #D1D5DB;
}

</style>
